import React from 'react';
import { motion } from 'framer-motion';
import { NODE_CATEGORIES, COLOR_CLASSES } from './nodeTypes';

/* Left rail palette — items are draggable onto the canvas.
   The canvas reads `application/voxinity-flow-node` from the dataTransfer
   to decide what type to drop. */
export default function NodePalette() {
  const onDragStart = (e, type) => {
    e.dataTransfer.setData('application/voxinity-flow-node', type);
    e.dataTransfer.effectAllowed = 'move';
  };
  return (
    <aside
      className="w-[260px] flex-shrink-0 border-r overflow-y-auto"
      style={{ background: 'var(--vox-chrome-bg)', borderColor: 'var(--vox-chrome-border)' }}
      data-testid="callflow-palette"
    >
      <div className="px-4 py-3 border-b" style={{ borderColor: 'var(--vox-chrome-border)' }}>
        <h3 className="text-sm font-semibold" style={{ color: 'var(--vox-text-primary)' }}>Add Nodes</h3>
        <p className="text-[11px] mt-0.5" style={{ color: 'var(--vox-text-secondary)' }}>Drag onto the canvas</p>
      </div>

      {NODE_CATEGORIES.map(cat => (
        <div key={cat.id} className="px-3 py-3 border-b" style={{ borderColor: 'var(--vox-chrome-border)' }}>
          <div className="text-[10px] font-bold uppercase tracking-widest mb-2 px-1" style={{ color: 'var(--vox-text-muted)' }}>{cat.label}</div>
          <div className="space-y-1.5">
            {cat.items.map(it => {
              const c = COLOR_CLASSES[it.color];
              const Icon = it.icon;
              return (
                <motion.div
                  key={it.type}
                  whileHover={{ x: 2 }}
                  whileTap={{ scale: 0.98 }}
                  draggable
                  onDragStart={(e) => onDragStart(e, it.type)}
                  className={`flex items-center gap-2.5 px-2.5 py-2 rounded-lg ${c.bg} border ${c.border} cursor-grab active:cursor-grabbing transition`}
                  data-testid={`palette-${it.type}`}
                  title={it.description}
                >
                  <div className={`w-7 h-7 rounded-md ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`}>
                    <Icon size={14} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className={`text-xs font-semibold ${c.text} truncate`}>{it.label}</div>
                    <div className="text-[10px] truncate" style={{ color: 'var(--vox-text-secondary)' }}>{it.description}</div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      ))}
    </aside>
  );
}
